import { render, staticRenderFns } from "./addpackage.vue?vue&type=template&id=6ca40d85"
import script from "./addpackage.vue?vue&type=script&lang=js"
export * from "./addpackage.vue?vue&type=script&lang=js"
import style0 from "./addpackage.vue?vue&type=style&index=0&id=6ca40d85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports